import {dataClient} from 'data-client'
import axios from 'axios';

const apiAxios = axios.create({
    baseURL: 'https://coaz.org:8085',
    withCredentials: true,
});

const client = dataClient({
    axios:apiAxios,
    authAxios:apiAxios,
    service:'cms',
    authService:'auth',
});

/* const apiAxios = axios.create({
    baseURL: 'http://localhost:8080',
    withCredentials: true,
});

const authAxios = axios.create({
    baseURL: 'http://localhost:8085',
    withCredentials: true,
});

const client = dataClient({
    axios:apiAxios,
    authAxios:authAxios,
    service:'',
    authService:'',
}); */

export default client;